<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chapname2">Dedication</h2>
<p class="center">The author would like to dedicate this book to the memory of Major General Adna R. Chaffee Jr. who is considered the father of the US Army Armoured Forces.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// teil1.vue?981f31ee